<template>
	<textarea
		ref="input"
		type="text"
		:name="name"
        cols="50" rows="5"
		v-bind="attributes"
		:value="currentValue"
		@input="handleInput"
		@change="handleChange"
		@focus="handleFocus"
		@blur="handleBlur"
	></textarea>
</template>

<script>
import basefield from '../../mixins/basefield'

export default {
	name: 'formit-textarea',
	mixins: [basefield],
}
</script>



// WEBPACK FOOTER //
// node_modules/vue-formit-fields/src/components/textarea/textarea.vue